import React from 'react'
import { Link } from 'react-router-dom';
import { tasks, levels, agents, referral, transacts, groups } from '../assets';

const Activities = () => {
    const pages = [
        {
            id: 1,
            link: '/tasks',
            name: 'Tasks',
            image_url: tasks,
        },
        {
            id: 2,
            link: '/levels',
            name: 'Levels',
            image_url: levels,
        },
        {
            id: 3,
            link: '/agents',
            name: 'Agents',
            image_url: agents,
        },
        {
            id: 4,
            link: '/referral',
            name: 'Referral',
            image_url: referral,
        },
        {
            id: 5,
            link: '/transacts',
            name: 'Transacts',
            image_url: transacts,
        },
        {
            id: 6,
            link: '/groups',
            name: 'Groups',
            image_url: groups,
        },
    ];
    return (
        <div className="flex justify-center items-center w-full my-2">
            <div className="grid grid-cols-3 md:grid-cols-6 gap-2 md:w-full">
                {pages.map((page) => (
                    <Link to={page.link} key={page.id} className="flex flex-col flex-shrink-0 bg-white hover:bg-slate-50 shadow-lg max-md:h-[100px] max-md:w-[100px] md:h-[120px] md:w-[120px] lg:h-[150px] lg:w-[150px] max-xl:h-[150px] max-xl:w-[150px] 2xl:h-[200px] 2xl:w-[200px] p-2 rounded-[12px] cursor-pointer items-center justify-center">
                        <img src={page.image_url} className="flex object-contain h-[60%] w-full shrink-0" />
                        <div className="text-center text-cyan-800 mt-2 max-md:mt-1">{page.name}</div>
                    </Link>
                ))}
            </div>
        </div>
    )
}

export default Activities
